import type { PageLayoutProps } from "@/features/eventDetails/components/Layout/Layout"
import type { PagesRouterPage, PagesRouterPageProps } from "@/types"
import type { GetServerSideProps } from "next"

import { PageLayout } from "@/features/eventDetails/components/Layout/Layout"
import { getPageLayoutServerSideProps } from "@/features/eventDetails/server/getPageLayoutServerSideProps"

type EventDetailsPageType = PagesRouterPage<PageLayoutProps>
const EventDetailsPage: EventDetailsPageType = props => {
  return <PageLayout {...props} />
}

export const getServerSideProps: GetServerSideProps<PagesRouterPageProps<PageLayoutProps>> =
  getPageLayoutServerSideProps

export default EventDetailsPage
